var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconDashboard = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.0973 3.00403C6.82512 3.42758 3.42758 6.82512 3.00403 11.0973C2.95477 11.5941 3.36428 12 3.86357 12H11.096C11.5953 12 12 11.5953 12 11.096V3.86357C12 3.36428 11.5941 2.95477 11.0973 3.00403Z",
  fill: "#707070"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.16406 14.1001C4.90933 18.0289 8.36117 20.9997 12.5068 20.9997C17.1967 20.9997 20.9987 17.1977 20.9987 12.5078C20.9987 8.36215 18.0279 4.9103 14.0991 4.16504V11.4463C14.0991 12.912 12.911 14.1001 11.4453 14.1001H4.16406Z",
  fill: "#707070"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconDashboard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_dashboard.6f0fb1f66dc2ef14d3d6206b0da75db0.svg";